import { render, staticRenderFns } from "./BasemapSwitchOrder.vue?vue&type=template&id=451587a6&scoped=true"
import script from "./BasemapSwitchOrder.vue?vue&type=script&lang=js"
export * from "./BasemapSwitchOrder.vue?vue&type=script&lang=js"
import style0 from "./BasemapSwitchOrder.vue?vue&type=style&index=0&id=451587a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451587a6",
  null
  
)

export default component.exports